import PocketBase, {type AuthModel} from 'pocketbase'

const pocketBaseURL = import.meta.env.VITE_API_URL

export const pocketBase = new PocketBase(pocketBaseURL)

export interface PocketBaseAuthState {
  token: string
  model: AuthModel | null
  isValid: boolean
}

type AuthStateListener = (state: PocketBaseAuthState) => void | Promise<void>

const authStateListeners = new Set<AuthStateListener>()
let stopAuthStoreListener: (() => void) | null = null

export function getPocketBaseAuthState(): PocketBaseAuthState {
  return {
    token: pocketBase.authStore.token,
    model: pocketBase.authStore.model,
    isValid: pocketBase.authStore.isValid,
  }
}

function notifyAuthStateListeners(): void {
  const state = getPocketBaseAuthState()

  for (const listener of authStateListeners) {
    void Promise.resolve(listener(state)).catch((error: unknown) => {
      console.error('PocketBase auth-state listener failed', error)
    })
  }
}

/**
 * Shares one PocketBase auth-store subscription across React mounts and removes
 * it as soon as the final consumer unmounts.
 */
export function subscribeToPocketBaseAuthState(
  listener: AuthStateListener,
  fireImmediately = true,
): () => void {
  authStateListeners.add(listener)

  if (stopAuthStoreListener === null) {
    stopAuthStoreListener = pocketBase.authStore.onChange(notifyAuthStateListeners)
  }

  if (fireImmediately) {
    void Promise.resolve(listener(getPocketBaseAuthState())).catch((error: unknown) => {
      console.error('PocketBase auth-state listener failed', error)
    })
  }

  return () => {
    authStateListeners.delete(listener)

    if (authStateListeners.size === 0 && stopAuthStoreListener !== null) {
      stopAuthStoreListener()
      stopAuthStoreListener = null
    }
  }
}

export function getPocketBaseAuthHeaders(): HeadersInit {
  return {Authorization: `Bearer ${pocketBase.authStore.token}`}
}
